import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { getSlot } from "@/mds/utils/slots";
import { MDSSidebarSectionItemSlotName } from "@/mds/components/sidebar/sidebar.types";
import { MDSText, MDSTextOverflow, MDSTextVariant } from "@/mds/components/text";
import { HTMLAttributes, ReactNode } from "react";
import {
  StyledSectionItemContainer,
  StyledSectionItemContainerLeft,
  StyledSectionItemContainerRight,
} from "@/mds/components/sidebar/sidebar-section.styles";
import styled from "@emotion/styled";

interface MDSSidebarSectionItemProps extends HTMLAttributes<HTMLDivElement> {
  iconKind: MdsIconKind | ReactNode;
  label: string;
  children?: ReactNode;
  isDisabled?: boolean;
  indent?: boolean;
}

export const MDSSidebarSectionItem = ({
  iconKind,
  label,
  indent,
  ...props
}: MDSSidebarSectionItemProps) => {
  const rightButtons = getSlot(props.children, MDSSidebarSectionItemSlotName.ButtonsRight);

  return (
    <StyledSectionItemContainer $indent={indent} {...props}>
      <StyledSectionItemContainerLeft>
        {typeof iconKind === "string" ? (
          <StyledSectionItemIcon kind={iconKind as MdsIconKind} />
        ) : (
          iconKind
        )}
        <MDSText
          variant={MDSTextVariant.TextS}
          overflow={MDSTextOverflow.Ellipsis}
          numberOfLines={1}
        >
          {label}
        </MDSText>
      </StyledSectionItemContainerLeft>
      {rightButtons && (
        <StyledSectionItemContainerRight data-right-buttons>
          {rightButtons}
        </StyledSectionItemContainerRight>
      )}
    </StyledSectionItemContainer>
  );
};

const StyledSectionItemIcon = styled(MdsIcon)`
  & .mds-icon {
    font-size: 11px;
    height: 11px;
    width: 11px;
  }
`;
